import i18n from '@/lib/i18n'
import { createToaster } from '@chakra-ui/react/toast'

/**
 * Standalone Toast Service
 * Can be used outside React components (e.g., in API client, interceptors)
 */
export const toaster = createToaster({
  placement: 'bottom-end',
  pauseOnPageIdle: true,
})

/**
 * Toast Service
 * Global toast notifications that can be called from anywhere
 */
export const toastService = {
  success: (options) => {
    const { title, description, ...rest } = options || {}
    return toaster.create({
      type: 'success',
      title,
      description,
      duration: 5000,
      ...rest,
    })
  },

  error: (options) => {
    const { title, description, ...rest } = options || {}
    return toaster.create({
      type: 'error',
      title,
      description,
      duration: 7000,
      ...rest,
    })
  },

  warning: (options) => {
    const { title, description, ...rest } = options || {}
    return toaster.create({
      type: 'warning',
      title,
      description,
      duration: 5000,
      ...rest,
    })
  },

  info: (options) => {
    const { title, description, ...rest } = options || {}
    return toaster.create({
      type: 'info',
      title,
      description,
      duration: 5000,
      ...rest,
    })
  },

  // Network error notification
  networkError: () => {
    return toaster.create({
      type: 'error',
      title: i18n.t('errors.networkError'),
      description: i18n.t('errors.networkErrorDesc'),
      duration: 10000,
    })
  },

  // Server error notification
  serverError: (message) => {
    return toaster.create({
      type: 'error',
      title: i18n.t('errors.serverError'),
      description: message || i18n.t('errors.serverErrorDesc'),
      duration: 7000,
    })
  },

  // Generic toast
  show: (options) => {
    return toaster.create({
      duration: 5000,
      ...(options || {}),
    })
  },
}

export default toastService
